// TODO - remove lint disable when editing this file
/* eslint-disable */
import { get } from 'lodash'
export default (story) => {
  if (!story || !story.planning) {
    throw new Error(`Can not convert empty story`)
  } else {
    return {
      storyId: story._id,
      isPublished: get(story, ['additional_properties', 'is_published'], false),
      storyNote: story.planning.internal_note || '',
      canonicalWebsite: story.canonical_website,
    }
  }
}
